export type MonthOverMonthChangeType = 'increase' | 'decrease' | 'no-change';

export interface MonthOverMonthDeltaInput {
  percentageChange: number;
  changeType: MonthOverMonthChangeType;
}

export type MonthOverMonthDisplayVariant = 'positive' | 'negative' | 'neutral';

export function getSignedMonthOverMonthChange({
  percentageChange,
  changeType,
}: MonthOverMonthDeltaInput): number {
  if (changeType === 'increase') {
    return percentageChange;
  }
  if (changeType === 'decrease') {
    return -percentageChange;
  }
  return 0;
}

export function getMonthOverMonthDisplayVariant(
  signedChange: number,
): MonthOverMonthDisplayVariant {
  if (signedChange >= 1) {
    return 'positive';
  }
  if (signedChange <= -1) {
    return 'negative';
  }
  return 'neutral';
}

export function formatMonthOverMonthPercentLabel(
  signedChange: number,
): string {
  if (signedChange >= 1) {
    return `+${formatPercentValue(signedChange)}%`;
  }
  if (signedChange <= -1) {
    return `${formatPercentValue(signedChange)}%`;
  }
  return '0%';
}

function formatPercentValue(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded);
}

export function formatLastMonthStudentUnitsComparison(
  students: number,
  units: number,
): string {
  const studentLabel = `${students} student${students === 1 ? '' : 's'}`;
  const unitLabel = `${units} Unit${units === 1 ? '' : 's'}`;
  return `of ${studentLabel} | ${unitLabel}`;
}

export function toMonthOverMonthStatDelta(
  delta: MonthOverMonthDeltaInput | undefined,
  comparisonDetail?: string,
) {
  const signedChange = getSignedMonthOverMonthChange({
    percentageChange: delta?.percentageChange ?? 0,
    changeType: delta?.changeType ?? 'no-change',
  });

  return {
    signedChange,
    variant: getMonthOverMonthDisplayVariant(signedChange),
    label: formatMonthOverMonthPercentLabel(signedChange),
    comparisonDetail,
  };
}
